var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-view'),_c('b-container',[_c('stepper-view',{attrs:{"steps":_vm.steps,"step":_vm.step}}),_c('router-view')],1),_c('footer-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }